
<div class="card large-horizontal-card">
  <div class="row">
    <div [class]="'col-'+breakpoint+'-4'">
      <a [routerLink]="[content.slug]">
        <div class="img-holder">
          @if (content.video) {
            <div class="video-content">
              <i class="fa-solid fa-circle-play"></i>
              <p *transloco="let t">{{t('common.video')}}</p>
            </div>
          }
          @if (videoThumbnailUrl) {
            <img class="img-fluid main-img" [src]="videoThumbnailUrl" [alt]="'Video thumbnail'">
          }
          @if (!videoThumbnailUrl && (content.images | imageForRole:'thumbnail':true); as cover) {
            <img class="img-fluid main-img" [src]="cover | imageUrl:thumbnailTransformations" [alt]="cover.alt_text">
          }
          @if (content.rating) {
            <div class="rating">
              <pre class="rate-value"><b>{{content.rating}}</b></pre>
              <rating [(ngModel)]="content.rating" [max]="ratingMax" [readonly]="true"></rating>
            </div>
          }
        </div>
      </a>
    </div>
    <div [class]="'col-'+breakpoint+'-8'">
      <div class="text-content">
        <a class="title" [routerLink]="[content.slug]">{{content.title}}
        </a>
        <div class="badges">
          @for (tag of content.tags; track tag) {
            <span [ngClass]=" [tag.type == 'topic' ? 'badge-info' : 'badge-primary', 'badge badge-pill']">{{tag.name}}</span>
          }
          <!-- <span class="badge badge-pill badge-more" (click)="action()">
          <i class="fa-solid fa-angle-right"></i>
        </span> -->
      </div>
      @if (showDate && content.date) {
        <p class="text-muted small mb-1">{{content.date | date:'longDate'}}</p>
      }
      <p class="text">{{content.description}}</p>
      <div class="action">
        <button (click)="gotoContent()">
          <p *transloco="let t">{{content.video ? t('common.watch') : t('common.read')}}</p>
          <i class="fa-solid fa-angle-right"></i>
        </button>
        @if (content.video && content.duration) {
          <p class="reading-time">
            <span class="mx-1">{{content.duration}}</span><span *transloco="let t">{{t('common.minutes_abbreviated')}}</span>
          </p>
        }
      </div>
    </div>
  </div>
</div>
</div>